// The two rules of an owner's password a screen applies before asking the
// server (UC-25). Apart from password.ts so a test can read them without the
// API client, which needs the API's origin to load.

/** A password is 15 to 128 characters, counted as a person counts them. */
export const PASSWORD_MIN = 15;
export const PASSWORD_MAX = 128;

export function passwordLengthOk(password: string): boolean {
	const n = [...password].length;
	return n >= PASSWORD_MIN && n <= PASSWORD_MAX;
}

/** The minutes a lock still holds, rounded up, from the reply's seconds. */
export function lockMinutes(details: unknown): number {
	const seconds = (details as { retry_after_seconds?: unknown } | undefined)?.retry_after_seconds;
	return typeof seconds === 'number' && seconds > 0 ? Math.ceil(seconds / 60) : 1;
}
